
































































import Vue from 'vue'

import InputSizeForm from '@/groupBuy/components/requestList/InputSizeForm.vue'

import { formatOneDecimal } from '@/common/utils/common'
import { RequestItemModel, RequestSizeInputItem } from '@/groupBuy/types'
import { expiredDateFormat } from '@/groupBuy/utils'
import service from '@/groupBuy/services'
import { GroupBuyRequestUpdateAttributes } from 'types/globalTypes'
import { SYSTEM_ERROR } from '@/common/constants'

enum VIEW_MODES {
  EDIT,
  VIEW
}

export default Vue.extend({
  components: {
    InputSizeForm
  },
  props: {
    sizeInputItem: {
      type: Object as () => RequestSizeInputItem,
      required: true
    },
    quantityUnit: {
      type: String,
      required: true
    },
    request: {
      type: Object as () => RequestItemModel,
      required: true
    }
  },
  data(): {
    currentView: number
  } {
    return {
      currentView: VIEW_MODES.VIEW
    }
  },
  computed: {
    formattedCreatedDate(): string {
      const date = this.sizeInputItem.createdAt ? new Date(this.sizeInputItem.createdAt) : null
      return expiredDateFormat(date)
    },
    totalQuantity(): number | string {
      const total = this.sizeInputItem.sizeItems.reduce((sum: number, item) => {
        sum+= (item.quantity || 0)
        return sum
      }, 0)
      return formatOneDecimal(total) || 0
    },
    VIEW_MODES() {
      return VIEW_MODES
    }
  },
  methods: {
    formatOneDecimal,
    async removeItem() {
      const confirmResult = confirm('回答を削除しますか？(OKを押すと削除されます)')
      if (confirmResult) {
        const res =  await service.deleteRequestInputSize(this.sizeInputItem.uuid).catch(() => {
          alert(SYSTEM_ERROR.UNKNOWN)
        })
        if (res) {
          this.$emit('removeSizeInput')
        }
      }
    },
    saveChange(payload: GroupBuyRequestUpdateAttributes) {
      service.updateRequestInputSize(this.sizeInputItem.uuid, payload).then(res => {
        if (res?.updateGroupBuyRequest) {
          this.$emit('updateSizeInput')
          this.currentView = this.VIEW_MODES.VIEW
        }
      }).catch(() => {
        alert(SYSTEM_ERROR.UNKNOWN)
      })
    }
  }
})
